"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-unused-vars */
/* eslint-disable indent */
const vue_property_decorator_1 = require("vue-property-decorator");
const ModelCompositorCropCount_1 = __importDefault(require("../abstract/models/ModelCompositorCropCount"));
let CropFilterItem = class CropFilterItem extends vue_property_decorator_1.Vue {
    modelCropCount() {
        return new ModelCompositorCropCount_1.default(this.crop.crop.id, this.crop.crop.logo_name, this.crop.crop.crop_name, this.crop.crop.color, this.crop.count);
    }
    get srcCrop() {
        if (this.active) {
            return this.modelCropCount().imgSrc('white');
        }
        else {
            return this.modelCropCount().imgSrc('color');
        }
    }
    get cropName() {
        return this.modelCropCount().getName();
    }
    get count() {
        return this.modelCropCount().getCount();
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], CropFilterItem.prototype, "crop", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], CropFilterItem.prototype, "active", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('crop')
], CropFilterItem.prototype, "modelCropCount", null);
CropFilterItem = __decorate([
    (0, vue_property_decorator_1.Options)({})
], CropFilterItem);
exports.default = CropFilterItem;
